import styled from "styled-components";
import { Container, Columns, Column } from "../../sdk/Layout";
import { Button } from "../../sdk/Button";

export const Wrapper = styled(Container)`
    max-width: 1570px !important;
`;

export const Content = styled(Columns)`
    min-height: 500px;
    background-color: ${props => props.theme.grayLight};
    overflow: hidden;
    border-radius: 10px;
    @media (max-width: 768px) {
        min-height: auto;
    }
`;

export const Text = styled(Column)`
    background-color: ${props => props.theme.white};
    width: 400px;
    padding: 50px;
    img {
        width: 150px;
        height: auto;
        display: block;
        margin-bottom: 40px;
        filter: ${props => props.theme.darkMode && 'brightness(100)'};
    }
    p {
        margin: 0;
        padding: 0;
        font-size: 17px;
        color: ${props => props.theme.primaryDark};
        letter-spacing: 0;
        line-height: 30px;
    }
    ${Button} {
        margin-top: 40px;
        svg {
            width: 12px !important;
            height: 12px !important;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
        padding: 20px;
        img {
            width: 100px;
            margin: auto;
            margin-bottom: 20px;
        }
        p {
            font-size: 15px;
            line-height: 24px;
        }
        & ${Button} {
            margin-top: 15px;
        }
    }
`;

export const Cover = styled(Column)`
    padding: 0;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    @media (max-width: 768px) {
        position: relative;
        padding-top: 45%;
        img {
            position: absolute;
            left: 0;
            top: 0;
        }
    }
`;
